import Section from './Section.jsx';
import TrafficMap from './TrafficMap.jsx';

export default function TravelIn({ note }) {
  return (
    <Section id="travel" title="Getting in" eyebrow="Airport + live traffic">
      {note && <p className="mb-4 leading-relaxed">{note}</p>}
      <TrafficMap />
    </Section>
  );
}
